import type { TableSelectedCell } from '@/components/custom/erp';
import type { ChiTietGiayBaoNo } from '@/types/schemas';
import { useTableRows } from '@/components/custom/erp';

export type SelectedCellInfo = TableSelectedCell;

export interface DetailRow extends Omit<ChiTietGiayBaoNo, 'uuid' | 'id_hd_data' | 'ma_thue_data'> {
  uuid: string;
  line?: number;
  id_hd_data?:
    | (ChiTietGiayBaoNo['id_hd_data'] & {
        tien_tren_hd?: ChiTietGiayBaoNo['tien_nt'];
        tk_data?: NonNullable<ChiTietGiayBaoNo['id_hd_data']>['tk_data'];
      })
    | null;
  ma_thue_data?:
    | (NonNullable<ChiTietGiayBaoNo['ma_thue_data']> & {
        thue_suat?: ChiTietGiayBaoNo['thue_suat'];
        tax_rate?: ChiTietGiayBaoNo['thue_suat'];
      })
    | null;
}

export function useDetailRows(
  initialRows: DetailRow[] = [],
  onChange?: (rows: DetailRow[]) => void,
  onFieldValueChange?: (row: DetailRow, field: string, value: unknown) => Partial<DetailRow>
) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handleMoveRow,
    handlePasteRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<DetailRow>({
    initialRows,
    defaultRows: 1,
    onChange,
    onFieldValueChange,
    defaultField: 'dien_giai'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
